import React from 'react'
import {
  MultilangParseFunction,
  MultiLanguageString,
  MultilangWriteFunction,
  parseMultilangJSON,
  writeMultilangJSON,
} from 'services/utils/multilangParseWrite'
import {
  getCurrentLang,
  useLangContext,
} from '../../services/contexts/LangContext'

export type LocalizedInputProps = {
  writeFunction?: MultilangWriteFunction
  parseFunction?: MultilangParseFunction
  children: JSX.Element
}

const LocalizedInput: React.FC<LocalizedInputProps> = ({
  writeFunction = writeMultilangJSON,
  parseFunction = parseMultilangJSON,
  children,
}) => {
  const { currentLang } = useLangContext()

  let cachedValue: MultiLanguageString

  const formatHandler = (v: string) => {
    const parsed = parseFunction(v)
    cachedValue = parsed
    return parsed[currentLang]
  }

  const parseHandler = (v: string) => {
    const lang =
      currentLang === getCurrentLang() ? currentLang : getCurrentLang()
    return writeFunction(lang, v, cachedValue)
  }

  return React.cloneElement(children, {
    parse: parseHandler,
    format: formatHandler,
  })
}

export default LocalizedInput
